import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import MainNavigation from "../components/navigation/MainNavigation";
import Footer from "../components/common/Footer/Footer";
import LocationCompletionModal from "../components/common/LocationCompletionModal";
import { isAdminPanelRoute } from "../admin/navigation/adminNavigation";
import AdminLayoutShell from "../admin/navigation/AdminLayoutShell";
import "../admin/navigation/AdminShell.css";
import "./Root.css";

const FULLSCREEN_AUTH_ROUTES = new Set([
  "/login",
  "/sign-up",
  "/sign-up/complete-profile",
  "/Email-Screen",
  "/OTP-Screen",
  "/reset-password",
]);

const CUSTOMER_ROUTE_PREFIXES = [
  "/customer",
  "/dashboard",
  "/user/profile",
  "/user/edit-profile",
  "/user/upload-documents",
  "/user/payment-details",
  "/user/upload-payment-screen-shot",
];

function RootLayout() {
  const authState = useSelector((state) => state.auth);
  const loggedInUser = authState.user;
  const location = useLocation();
  const adminPanelRoute = isAdminPanelRoute(location.pathname, authState);
  const adminLoginRoute = location.pathname === "/admin-login";
  const isFullscreenAuthRoute = FULLSCREEN_AUTH_ROUTES.has(location.pathname);
  const isCustomerDashboardRoute = CUSTOMER_ROUTE_PREFIXES.some((prefix) =>
    location.pathname === prefix || location.pathname.startsWith(`${prefix}/`)
  );
  const shouldShowSiteNavbar = !adminLoginRoute && !isFullscreenAuthRoute;
  const isNoFooterRoute = location.pathname === "/post/add-post";
  const shouldShowSiteFooter =
    !adminLoginRoute && !isFullscreenAuthRoute && !isCustomerDashboardRoute && !isNoFooterRoute;
  const shouldShowLocationCompletionModal =
    loggedInUser && !adminLoginRoute && !isFullscreenAuthRoute;

  if (adminPanelRoute) {
    return (
      <div className="admin-root-layout">
        <AdminLayoutShell>
          <Outlet />
        </AdminLayoutShell>
      </div>
    );
  }

  return (
    <div className="rootl">
      {shouldShowSiteNavbar ? <MainNavigation /> : null}
      {shouldShowLocationCompletionModal ? <LocationCompletionModal /> : null}
      <main className="rootl__main">
        <Outlet />
      </main>
      {shouldShowSiteFooter ? <Footer /> : null}
    </div>
  );
}

export default RootLayout;
